<template>
  <div class="description">
    <div v-if="!enterText">
      <div :class="{'desktop-only': !firstFeelingLuckyPage()}">
        <h1 class="heading mb3">Feeling Lucky?</h1>
        <p
          class="sub-heading"
        >Click HIT ME to generate random design combinations. Fine tune the design yourself, or boldly purchase what the universe created for you.</p>
      </div>
      <transition name="fade">
        <div key="3" v-show="show" v-if="buttons" class="cta-btn-wrapper">
          <transition name="slide">
            <button
              @click="editMe"
              key="1"
              v-show="show"
              type="button"
              class="btn btn--inverse btn--right btn--finetune"
              data-text="Fine Tune This Design"
            >Fine Tune This Design</button>
          </transition>
          <transition name="slide2">
            <button
              class="btn btn--right btn--shutup"
              v-show="show"
              key="2"
              @click="buyMe"
              type="button"
              data-text="Shut Up and Take My Money"
            >Shut Up and Take My Money</button>
          </transition>
        </div>
      </transition>
    </div>
    <div v-else>
      <div class="speaker-text-entry">
        <h1 class="heading mb3">Damn that's hot.</h1>
        <p class="sub-heading mb3">Finish it up with text, or leave it blank.</p>
      </div>
      <div class="mobile-text-buttons">
        <ConfigureText :show-text-input="false" feelingLucky/>
      </div>
      <div class="desktop-only">
        <ConfigureText :show-text-input="true" feelingLucky/>
      </div>
    </div>
  </div>
</template>


<script>
import Button from "../Button.vue";
import ConfigureText from "../configure/Text.vue";
export default {
  data() {
    return {
      show: false,
      currentHeight: 0
    };
  },
  components: { Button, ConfigureText },
  props: {
    buttons: Boolean,
    enterText: Boolean
  },
  computed: {
    textLink: function() {
      return "/feeling-lucky/" + this.$route.params.id + "/text";
    }
  },
  mounted() {
    // triggers the animations
    this.show = true;
    if (this.$route.name === "feeling-lucky") {
      this.currentHeight = 0;
    }
  },
  watch: {
    $route(to, from) {
      if (from.name === "feeling-lucky" && to.name === "SpeakerChoices") {
        this.show = false;
        setTimeout(() => (this.show = true), 0);
      }
    }
  },
  methods: {
    firstFeelingLuckyPage() {
      if (this.$route.params.id) {
        return false;
      }
      return true;
    },
    selectConfiguration() {
      const config = this.$store.state.feelingLucky.filter(
        rando => rando.Id === parseInt(this.$route.params.id)
      )[0];
      const configurationOptions = {
        Caps: config.Caps,
        Fabric: config.Fabric,
        Icon: config.Icon,
        Loop: config.Loop,
        Spine: config.Spine
      };
      Object.keys(configurationOptions).forEach(key => {
        this.$store.commit("selectOption", {
          CategoryName: key,
          Id: configurationOptions[key]
        });
      });
    },
    buyMe() {
      this.selectConfiguration();
      this.$router.push({
        name: 'SpeakerText',
        params: {
          id: this.$route.params.id
        }
        //path: `/feeling-lucky/${this.$route.params.id}/text`
      });
    },
    editMe() {
      this.selectConfiguration();
      this.$store.commit("editingFeelingLucky", true);
      this.$router.push({
        name: 'Fabric'
      });
    },
    goToReview() {
      const that = this;
      this.$router.push({
        name: "completed-design"
      });
    }
  }
};
</script>


<style lang="scss">
@import "../../scss/variables";

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
  transition-delay: 0.2s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.slide-enter-active,
.slide-leave-active {
  transition: transform 0.2s ease-out;
  transition-delay: 0.2s;
}

.slide-enter,
.slide-leave-to {
  transform: translateX(-5px);
}

.slide2-enter-active,
.slide2-leave-active {
  transition-delay: 0.2s;
  @media (min-width: 992px) {
    transition: transform 0.2s ease-out;
    transition-delay: 0.3s;
  }
}

.slide2-enter,
.slide2-leave-to {
  transform: translateX(-5px);
}

.mobile-only {
  display: block;
  @media (min-width: 992px) {
    display: none;
  }
}

.mobile-text-buttons {
  @media (min-width: 992px) {
    display: none;
  }
}

.desktop-only {
  display: none;
  @media (min-width: 992px) {
    display: block;
  }
}

.speaker-text-entry {
  display: none;
  @media (min-width: 992px) {
    display: block;
  }
}

.desktop-only {
  display: none;
  @media (min-width: 992px) {
    display: block;
  }
}

.description {
  margin-left: auto;
  margin-right: auto;
  text-align: center;
  box-sizing: border-box;
  padding-left: 1em;
  padding-right: 1em;
  width: 100%;
  @media (max-width: 991px) {
    height: 90px;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  @media (min-width: 992px) {
    text-align: left;
    max-width: 420px;
    width: 40%;
    margin: 0;
    position: relative;
    padding-top: 0;

    @media (min-height: 600px) {
      padding-top: 40px;
    }
    @media (min-height: 700px) {
      padding-top: 40px;
    }
    @media (min-height: 900px) {
      padding-top: 100px;
    }
  }
  @media (min-width: 1200px) {
    padding-top: 0;

    @media (min-height: 600px) {
      padding-top: 40px;
    }
    @media (min-height: 700px) {
      padding-top: 40px;
    }
    @media (min-height: 900px) {
      padding-top: 100px;
    }
  }
}

.cta-btn-wrapper {
  max-width: 400px;
  margin-left: auto;
  margin-right: auto;
  button {
    margin-bottom: 0.4em;
    width: 100%;
    @media (min-width: 992px) {
      width: auto;
    }
  }
  @media (min-width: 610px) and (max-width: 991px) {
    display: flex;
    max-width: 600px;
    margin-left: auto;
    margin-right: auto;
    .btn--finetune {
      background: #000 none;
      border: 4px solid #000;
      padding: 1rem 1.4rem;
      margin-right: 1em;
    }
    .btn--shutup {
      background: transparent none;
      border: 4px solid #000;
      padding: 1rem 1.4rem;
    }
  }
  @media (min-width: 992px) {
    display: flex;
    flex-direction: column;
    height: 176px; // same as the circle button
    top: 70%;
    transform: translateY(-50%);
    position: absolute;
    align-items: flex-start;
    justify-content: center;
    @media (min-height: 560px) {
      top: 60%;
    }
    @media (min-height: 680px) {
      top: calc(44.776% + 88px); // 88 = height of element/2
    }
  }
}

.heading {
  font-family: $font;
  font-size: 1.75rem;
  text-transform: uppercase;
  font-weight: bold;
  @media (min-width: 992px) {
    font-size: 2.5rem;
  }
  @media (min-width: 1150px) {
    font-size: 3rem;
  }
}

.sub-heading {
  line-height: 1.3;
  color: $greyDark;
  font-family: sans-serif;
  @media (max-width: 610px) {
    max-width: 400px;
    margin-left: auto;
    margin-right: auto;
  }

  @media (min-width: 992px) {
    color: black;
    font-family: $font;
    font-size: 1.15rem;
    text-transform: uppercase;
    font-weight: bold;
  }
}

.body-text {
  font-family: Arial, sans-serif;
  font-size: 1rem;
  line-height: 1.3;
  color: $greyDark;
}
</style>
